'use client';

import React, { ReactNode } from 'react';

import { IDictionary, LocaleProvider } from '@/lib/context/locale-provider';

// 서버 컴포넌트에서 불러서 사용 가능
function ClientProvider({
  children,
  dictionary,
}: {
  children: ReactNode;
  dictionary: IDictionary;
}) {
  return <LocaleProvider dictionary={dictionary}>{children}</LocaleProvider>;
}

export default ClientProvider;
